// extracted by mini-css-extract-plugin
module.exports = {"tooltip-heading":"tooltip-heading__3n-C5","tooltip-content":"tooltip-content__1TxX1","tooltip-footer":"tooltip-footer__3HGy6"};